import type { FC } from 'react';

import cx from 'classnames';

interface IosAddIconProps {
  className?: string;
}

const IosAddIcon: FC<IosAddIconProps> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" className={cx(className)}>
      <rect x="80" y="80" width="352" height="352" rx="80" ry="80" stroke="currentColor" strokeWidth={32} />
      <path stroke="currentColor" strokeLinecap="round" strokeWidth={32} d="M256 176v160M176 256h160" />
    </svg>
  );
};

export default IosAddIcon;
